import cx from "classnames";
import { Link } from "react-router-dom";
import { SidebarDirectMessagesSubMenu } from "../../_components/sidebar/direct-messages-submenu.component";
import { COMMUNITY_HOMEPAGE_ROUTE } from "../community-home/community-home.page";

function DirectMessageSidebarComponent({
  user,
  community,
  addToast = (e) => {},
  history,
  isSidebarOpen = false,
  sidebarIgnoresCommunitySwitcher = false,
  setIsSidebarOpen = (e) => {},
}) {
  return (
    <>
      <div
        onClick={(e) => {
          setIsSidebarOpen(false);
        }}
        className={cx("Sidebar CommunitySettingsSidebar ", {
          open: isSidebarOpen,
        })}>
        <div className="sidebar-content theme-bg-surface  py-2">
          <Link
            to={COMMUNITY_HOMEPAGE_ROUTE}
            className="flex items-center space-x-4  rounded px-2">
            <span className="mt-1">
              <i className="fi fi-rr-angle-left text-md theme-text-default"></i>
            </span>
            <span className="theme-text-default"> Go Back to Community</span>
          </Link>
          <SidebarDirectMessagesSubMenu />
        </div>
      </div>
    </>
  );
}

export default DirectMessageSidebarComponent;
